<template>
  <div>
    <v-container v-if="order">
      <div class="info-block order-top">
        <div class="product-top">
          <div class="product-img">
            <img onerror="this.className= 'none';" :src="order.imageUrl" />
            <div class="none-img"></div>
          </div>
          <div class="product-info">
            <h1>{{ order.productName }}</h1>
            <div v-show="order.isGroupCoupon" class="product-type">
              成套票券
            </div>
            <div v-if="!isGoods" class="product-expire">
              有效期限：{{ order.usingEndTime | formatDateTime('YYYY/MM/DD') }}
            </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="product-btm">
          <p v-if="order.couponType !== 7">剩餘數量 {{ ticketAmount }} 份</p>
          <template v-if="!isGoods">
            <v-btn
              v-if="order.statusTypes.indexOf(0) != -1 && ticketAmount > 0"
              dark
              depressed
              color="#1DA7FC"
              height="48"
              block
              @click="contactService()"
            >
              <div>立即兌換</div>
            </v-btn>
            <v-btn
              v-else
              disabled
              depressed
              dark
              style="background-color: #d8d8d8;"
              height="46"
              block
            >
              <div v-if="order.statusTypes.indexOf(2) != -1">已過期</div>
              <div v-else-if="order.statusTypes.indexOf(1) != -1">已使用</div>
              <div v-else-if="order.returnStatus != 0 && order.returnStatus == 9">
                {{ returnString[order.returnDetail[0].returnStatus] || '請洽客服' }}
              </div>
              <div v-else-if="order.returnStatus != 0 && order.returnStatus != 9">
                {{ returnString[order.returnStatus] || '請洽客服' }}
              </div>
              <div v-else>已使用</div>
            </v-btn>
          </template>
        </div>
      </div>
      <div class="info-block order-btm">
        <!-- --訂單編號-- -->
        <div class="info-row">
          <h2>訂單編號</h2>
          <div class="inline-block">
            <p ref="orderNo">{{ order.orderNo }}</p>
            <div
              class="orderNo-copy"
              v-clipboard:copy="order.orderNo"
              v-clipboard:success="onCopyOrderNo"
            >
              <img src="@/assets/img/icon/copy-orderNo.svg" />
              <span>複製</span>
            </div>
          </div>
        </div>
        <!-- --商品資訊-- -->
        <div class="info-row">
          <h2>商品資訊</h2>
          <p v-if="order.choseStore">使用分店：{{ order.choseStore }}</p>
          <p>數量：{{ order.quantity }}</p>
          <p>金額：${{ order.payAmount }}</p>
        </div>
        <!-- --付款資訊-- -->
        <div v-if="!isZeroCoupon" class="info-row">
          <h2>付款資訊</h2>
          <div class="inline-block">
            <p>商品總金額</p>
            <p>${{ order.totalAmount }}</p>
          </div>
          <div class="inline-block">
            <p>優惠折扣</p>
            <p>{{ order.discountAmount }}</p>
          </div>
          <div class="inline-block">
            <p>付款金額</p>
            <p>${{ order.payAmount }}</p>
          </div>
          <div class="hr"></div>
          <div class="inline-block">
            <p>付款方式</p>
            <p>{{ paymentInfo }}</p>
          </div>
          <div class="inline-block">
            <p>付款時間</p>
            <p>{{ order.payTime }}</p>
          </div>
        </div>
        <!-- --發票資訊-- -->
        <div v-if="order.invoices.length > 0" class="info-row">
          <h2>發票資訊</h2>
          <div
            v-for="(invoice, i) in order.invoices"
            :key="i"
            class="mb-2"
          >
            <p>發票號碼：{{ invoice.invoiceNumber }}
              <span v-if="invoice.invoiceStatus == 3">(發票已作廢)</span>
              <span v-if="invoice.invoiceHandlingFee > 0">(退貨手續費)</span>
            </p>
            <p>開立方式：{{ invoice.invoiceMode }}</p>
            <p v-if="invoice.invoiceAddress">
              寄送地址：{{ invoice.invoiceAddress }}
            </p>
          </div>
        </div>
        <!-- --購買紀錄-- -->
        <div v-if="!isZeroCoupon" class="info-row">
          <h2>購買紀錄</h2>
          <div v-if="!isGoods">
            <p>訂購日期：{{ order.orderTime | formatDateTime('YYYY/MM/DD') }}</p>
            <p>付款日期：{{ order.payTime | formatDateTime('YYYY/MM/DD') }}</p>
            <p>使用期限：{{ order.usingEndTime | formatDateTime('YYYY/MM/DD') }}</p>
          </div>
          <div v-else>
            <p>訂購日期：{{ order.deliveryOrderLog.orderDate | formatDateTime('YYYY/MM/DD') }}</p>
            <p>付款日期：{{ order.deliveryOrderLog.payDate | formatDateTime('YYYY/MM/DD') }}</p>
            <p>出貨日期：{{ order.deliveryOrderLog.shipDate | formatDateTime('YYYY/MM/DD') }}</p>
            <div v-if="isGoods">
              <p>退貨期限：{{ order.deliveryOrderLog.returnLimitDate | formatDateTime('YYYY/MM/DD') }}</p>
            </div>
          </div>
        </div>
        <!-- --兌換紀錄-- -->
        <div v-if="order.redemptions.length > 0 && !isGoods" class="info-row">
          <h2>兌換紀錄</h2>
          <div
            v-for="(redemption, i) in order.redemptions"
            :key="i"
            :style="{ display: redemption.status == true ? 'block' : 'none' }"
          >
            <p>{{ redemption.verifiedTime }}</p>
            <p>
              <span class="dark-text">{{ redemption.verifiedStore }}</span>
              &nbsp;完成兌換&nbsp;
            </p>
          </div>
        </div>
        <!-- --收件地址-- -->
        <div v-if="isGoods" class="info-row">
          <h2>收件地址</h2>
          <div class="inline-block">
            <p>收件人</p>
            <p>{{ order.recipient.name }}</p>
          </div>
          <div class="inline-block">
            <p>手機號碼</p>
            <p>{{ order.recipient.mobile }}</p>
          </div>
          <div class="inline-block">
            <p>收件地址</p>
            <p>{{ order.recipient.address }}</p>
          </div>
        </div>
        <!-- --配送進度-- -->
        <div v-if="isGoods" class="info-row">
          <h2>配送進度</h2>
          <div class="inline-block">
            <p>物流單號：{{ order.shipInfo.shipNo }}</p>
            <div
              class="orderNo-copy"
              v-clipboard:copy="order.shipInfo.shipNo"
              v-clipboard:success="onCopyShipNo"
            >
              <img src="@/assets/img/icon/copy-orderNo.svg" />
              <span>複製</span>
            </div>
          </div>
          <div
            class="progress-content mt-4"
            :style="{ height: isExpand ? '184px' : '92px' }"
          >
            <div
              v-for="(msg, index) in order.shipInfo.shipStatus"
              :key="index"
              class="progress-item"
            >
              <div class="progress-item-image">
                <img src="@/assets/img/icon/check-red.svg" />
              </div>
              <div class="progress-item-text ml-4">
                {{ msg.shippingStatus }}
                <span class="progress-item-date">{{ msg.shippingDate }}</span>
              </div>
            </div>
            <div
              v-if="order.shipInfo.shipStatus.length > 2 && !isExpand"
              class="fade-cover"
            />
          </div>
          <div
            v-if="order.shipInfo.shipStatus.length > 2"
            class="progress-expand mt-4"
            @click="isExpand = !isExpand"
          >
            配送狀態
            <img
              class="ml-2"
              :style="isExpand ? 'transform: rotate(180deg);' : ''"
              src="@/assets/img/arrow-down.svg"
            />
          </div>
        </div>
        <!-- --退貨明細-- -->
        <div v-if="hasReturn" class="info-row">
          <h2>退貨明細</h2>
          <template v-if="isToHouse">
            <div
              v-for="(detail, index) in order.returnDetail"
              :key="'return' + index"
            >
              <p>退貨申請日：{{ detail.returnDate | formatDateTime('YYYY/MM/DD') }}</p>
              <div>申請退貨數：{{ detail.returning }}</div>
              <div>實際退貨數：{{ detail.returned }}</div>
              <div>退款金額：${{ detail.returnAmount }}</div>
              <div>退款帳號/卡號：{{ detail.returnAccount }}</div>
              <div>退貨進度：{{ detail.returnStatus }}</div>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(detail, index) in order.returnDetail"
              :key="'return' + index"
            >
              <p>退款申請日：{{ detail.returnDate | formatDateTime('YYYY/MM/DD') }}</p>
              <p>退款金額：${{ detail.returnAmount }}</p>
              <p v-if="detail.returnAccount">退款帳號/卡號：{{ detail.returnAccount }}</p>
              <p v-if="detail.returnStatus">退款進度：{{ returnString[detail.returnStatus] }}</p>
            </div>
          </template>
        </div>
        <!-- --權益說明-- -->
        <div v-if="order.restriction && order.restriction !== '<div></div>'" class="info-row">
          <h2>權益說明</h2>
            <div v-html="order.restriction"></div>
        </div>
        <!-- --按扭-- -->
        <div class="info-row">
          <v-btn
            v-if="!outer"
            dark
            depressed
            color="#1DA7FC"
            height="48"
            @click="goContactPage()"
            block
          >
            <div>聯絡客服</div>
          </v-btn>
          <v-btn
            v-if="!isZeroCoupon && !outer && order.returnStatus === 0 && order.availableQty > 0"
            color="#1DA7FC"
            height="48"
            @click="goReturnPage()"
            outlined
            block
            class="mt-4"
          >
            <div v-if="isGoods">我要退貨</div>
            <div v-else-if="order.availableQty">我要退款</div>
          </v-btn>
        </div>
      </div>
      <div class="copy-success-div" v-show="copySuccess">
        {{ copiedData }} 已複製
      </div>
      <v-bottom-sheet v-model="isSheetActive">
        <v-sheet class="text-center">
          <div class="pa-4">
            <div class="ticket-redeem-info">
              <div class="ticket-redeem-name">{{ order.productName }}</div>
              <div class="ticket-redeem-amount mt-1 mb-2">
                購買數量：{{ order.quantity }}
              </div>
            </div>
            <div class="ticket-redeem-option py-3">
              <div class="ticket-redeem-amount-title mr-2">兌換數量</div>
              <div class="ticket-redeem-amount-current">
                目前持有{{ ticketAmount }} 張
              </div>
              <div
                class="option-btn minus-btn"
                :class="{ disabled: redemptAmount === 1 }"
                @click="redemptAmount === 1 ? '' : editUsage(0)"
              />
              <div class="ticket-redeem-amount-number">{{ redemptAmount }}</div>
              <div
                class="option-btn add-btn"
                :class="{ disabled: redemptAmount === ticketAmount }"
                @click="redemptAmount === ticketAmount ? '' : editUsage(1)"
              />
            </div>
            <v-btn
              dark
              depressed
              :disabled="redemptAmount === 0"
              block
              class="mt-4 mb-2"
              color="#1DA7FC"
              height="46"
              @click="navToRedeem()"
            >
              兌換
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </v-container>
    <Spinner v-else bgc="#f6f6f6" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner.vue'
import moment from 'moment'

export default {
  name: 'OrderDetail',
  components: {
    Spinner,
  },
  data: function() {
    return {
      outer: 0,
      order: null,
      orderId: 0,
      orderNo: '',
      newOrderNo: '1',
      originTabTop: 0,
      isGoods: true,
      isExpand: false,
      isTabFix: false,
      isSheetActive: false,
      hasReturn: false,
      isToHouse: false,
      activeTab: 0,
      remainTimes: 1,
      ticketAmount: 0,
      redemptAmount: 1,
      paymentInfo: '',
      isOrderNeedAtm: false,
      showEditReturnDiscountMail: false,
      isCreditCardReturn: false,
      editInvtReturnDiscountEmail: '',
      copySuccess: false,
      copiedData: '',
      lastServiceNo: 0,
      returnString: {
        1: '退貨處理中',
        2: '退貨完成',
        3: '退貨失敗',
        4: '取消退貨',
        5: '退款失敗',
      },
    }
  },
  created: function() {
    window.addEventListener('scroll', this.handleScroll)
    if (this.isNumber(this.$route.params.oid)) {
      this.orderId = this.$route.params.oid
      this.orderNo = ''
    } else {
      this.orderId = 0
      this.orderNo = this.$route.params.oid
    }
    if (this.$route.query.outer && this.$route.query.outer != 0) {
      this.newOrderNo = this.$route.query.outer
    } else {
      this.newOrderNo = this.$route.params.nOid
    }
    this.getOrderDetail()
    // this.outer = this.$route.query.outer
  },
  mounted() {
    if (this.$refs.tabBar) {
      this.originTabTop = this.$refs.tabBar.offsetTop
    }
    this.getMaintenanceInfo()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    isMaintenance() {
      const startTime = moment(this.maintainStart, 'YYYY-MM-DD HH:mm:ss')
      const endTime = moment(this.maintainEnd, 'YYYY-MM-DD HH:mm:ss')
      return moment().isBetween(startTime, endTime) && this.maintainType == 2
    },
    goMaintenance() {
      this.$router.push('/Maintenance')
    },
    getMaintenanceInfo() {
      const maintainInfo = JSON.parse(localStorage.getItem('maintenanceInfo'))
      if (maintainInfo) {
        this.maintainStart = maintainInfo.startTime
        this.maintainEnd = maintainInfo.endTime
        this.maintainType = maintainInfo.maintenanceType
      }
    },
    onCopyOrderNo() {
      this.copySuccess = true
      this.copiedData = '訂單編號' + this.order.orderNo
      window.setInterval(() => (this.copySuccess = false), 3000)
    },
    onCopyShipNo() {
      this.copySuccess = true
      this.copiedData = '物流單號' + this.order.shipInfo.shipNo
      window.setInterval(() => (this.copySuccess = false), 3000)
    },
    isNumber(val) {
      const pattern = /^\d+$/g
      if (pattern.test(val) == false) {
        return false
      } else {
        return true
      }
    },
    selectTab(index) {
      this.activeTab = index
    },
    getFooterText() {
      return this.isGoods ? '退貨' : '退款'
    },
    contactService() {
      if (this.isMaintenance()) {
        this.goMaintenance()
      }else{
        this.remainTimes--
        this.isSheetActive = true
      }
    },
    editUsage(type) {
      this.redemptAmount = type
        ? this.redemptAmount + 1
        : this.redemptAmount - 1
    },
    navToRedeem() {
      this.$router.push({
        name: 'redeem',
        params: { amount: this.redemptAmount },
        query: {
          oid: this.orderId,
          nOid: this.isGift ? this.newOrderNo : '',
        },
      })
    },
    editReturnDiscountMail() {
      this.showEditReturnDiscountMail = !this.showEditReturnDiscountMail
    },
    saveReturnDiscountMail() {
      const self = this
      api
        .mailFrontCreditNote(self.orderId, self.editInvtReturnDiscountEmail)
        .then(function(res) {
          self.showEditReturnDiscountMail = !self.showEditReturnDiscountMail
          alert('折讓單已寄送到您的信箱')
        })
        .catch(function(err) {
          console.log(err)
        })
    },
    getLastServiceNo(exchangeTicketUrl) {
      const endIndex = exchangeTicketUrl.indexOf('?')
      const startIndex = exchangeTicketUrl.lastIndexOf('/') + 1
      this.lastServiceNo = exchangeTicketUrl.slice(startIndex, endIndex)
    },
    getOrderDetail() {
      const self = this
      api
        .getOrderDetail(
          self.orderId,
          this.isGift ? this.newOrderNo : '',
          self.orderNo
        )
        .then(function(res) {
          if (res.data.length !== 0) {
            self.order = JSON.parse(JSON.stringify(res.data))
            self.orderId = self.order.orderId
            self.getLastServiceNo(res.data.exchangeTicketUrl)
            if (
              self.order.paymentTypes != null &&
              self.order.paymentTypes.length > 0
            ) {
              for (let i = 0; i < self.order.paymentTypes.length; i++) {
                if (self.paymentInfo != '') {
                  self.paymentInfo += ' / '
                }
                if (self.order.paymentTypes[i].paymentType == '信用卡') {
                  self.isCreditCardReturn = true
                }
                self.paymentInfo +=
                  self.order.paymentTypes[i].paymentType +
                  ' ' +
                  self.order.paymentTypes[i].maskCardNo
              }
            }

            if (self.order.deliveryType === 1) {
              self.isGoods = false
            }
            if (!self.order.returnDetail) {
              self.order.returnDetail = []
            } else if (self.order.returnDetail.constructor != Array) {
              self.order.returnDetail = [self.order.returnDetail]
            }
            if (self.order.returnDetail.length) {
              self.editInvtReturnDiscountEmail =
                self.order.returnDetail[0].invtReturnDiscountEmail
            }
            self.ticketAmount = self.order.availableQty
            self.hasReturn =
              self.order.returnDetail.length &&
              self.order.returnDetail[0].returnDate != null
            self.isToHouse = self.order.deliveryType == 2
            self.isOrderNeedAtm = self.order.isOrderNeedAtm
            if (
              self.order.returnDetail.length &&
              self.order.returnDetail[0].returnAccount &&
              self.order.returnDetail[0].returnAccount.indexOf('ATM') > -1
            ) {
              self.isCreditCardReturn = false
            }
          }
        })
        .catch(err => {
          console.log(err)
          this.$bus.$emit('callAllert', {
            messageContent: '查無資料',
            callback: () => {
              if (localStorage.getItem('source') === 'e7g') {
                window.location = process.env.VUE_APP_E7G_HOME
              } else {
                this.$router.replace({ name: 'home' })
              }
            },
          })
          // this.$router.replace('/error?errorCode=' + err.code || '0000')
        })
    },
    goContactPage() {
      if (
        this.$route.params.lastServiceNo &&
        this.$route.params.lastServiceNo != 0
      ) {
        this.$router.push({
          name: 'serviceAskingPage',
          params: {
            type: 1,
            serviceNo: this.$route.params.lastServiceNo,
          },
        })
      } else if (this.lastServiceNo != 0) {
        this.$router.push({
          name: 'serviceAskingPage',
          params: {
            type: 1,
            serviceNo: this.lastServiceNo,
          },
        })
      } else {
        this.$router.push({
          name: 'contactCustomerServicePage',
          params: { questionType: 1, orderNo: this.order.orderNo },
        })
      }
    },
    goReturnPage() {
      const query = this.order.isOrderNeedAtm
        ? {
            orderNo: this.order.orderNo,
            isAtmRefund: this.order.isOrderNeedAtm,
            g: this.order.isGroupCoupon,
            type: this.isGoods ? 1 : 0,
            bid: this.order.orderId
          }
        : {
            orderNo: this.order.orderNo,
            g: this.order.isGroupCoupon,
            type: this.isGoods ? 1 : 0,
            bid: this.order.orderId
          }
      this.$router.push({
        name: 'returnReason',
        query: query,
        params: { fromOrder: 1 },
      })
    },
  },
  computed: {
    useMock() {
      return process.env.VUE_APP_USE_DEV == 'true'
    },
    isGift() {
      return this.newOrderNo != '1'
    },
    isZeroCoupon() {
      return this.order.couponType == 6
    },
    tabList() {
      if (this.order != null) {
        const tabList = []
        if (this.order.description && this.order.description != '<div></div>') {
          tabList.push('詳細介紹')
        }
        if (this.order.stores && this.order.stores.length) {
          tabList.push('店家資訊')
        }
        if (this.order.restriction && this.order.restriction != '<div></div>') {
          tabList.push('權益說明')
        }
        return tabList
      } else {
        return []
      }
    },
  },
  watch: {
    tabList() {
      this.activeTab = this.tabList[0]
    },
  },
}
</script>

<style lang="scss" scoped>

.order-group {
  display: inline-flex;
}

.container {
  background-color: #f3f5f8;
  overflow: hidden;
  padding: 16px;
}

::v-deep .v-sheet {
  border-radius: 8px 8px 0px 0px !important;
  // height: 250px !important;
}

::v-deep .v-btn__content {
  display: flex;
  flex-direction: column;
}

::v-deep .v-btn__content > div {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
}

::v-deep .v-btn__content > p {
  font-size: 11px;
  margin: 0px;
}

.ticket-redeem-info,
.ticket-redeem-option {
  border-bottom: solid 1px #ededed;
}

.ticket-redeem-info {
  text-align: left;
}

.ticket-redeem-name {
  font-size: 15px;
  font-weight: bold;
  color: #222222;
}

.ticket-redeem-amount {
  font-size: 13px;
  color: #9b9b9b;
}

.ticket-redeem-option {
  display: flex;
  align-items: center;
}

.ticket-redeem-amount-title {
  font-size: 15px;
  color: #4a4a4a;
}

.ticket-redeem-amount-current {
  font-size: 12px;
  color: #9b9b9b;
  flex: 1;
  text-align: left;
}

.ticket-redeem-amount-number {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin: 0px 20px;
}

.ticket-redeem-option > div.option-btn {
  width: 44px;
  height: 44px;
  opacity: 0.6;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1da7fc;
  background-color: #ffffff;
  border: solid 1px #1da7fc;
  &.disabled {
    color: #222222;
    background-color: #d8d8d8;
    border: none;
  }
}

.ticket-redeem-option > div.option-btn::after {
  font-size: 15px;
  font-weight: bold;
}

.minus-btn::after {
  content: '-';
}

.add-btn::after {
  content: '+';
}

.info-block {
  background-color: #ffffff;
  margin-bottom: 8px;
  text-align: left;
  line-height: 24px;
  border-radius: 16px;
  padding: 24px 16px;
}

.info-block-title {
  display: flex;
  font-size: 16px;
  font-weight: bold;
  color: #222222;
}

.tab-bar {
  display: flex;
  height: 44px;
  color: #4a4a4a;
  box-shadow: 0 1px 0 0 #ededed;
}

.tab-bar_fixed {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #ffffff;
  transition: all 0.05s;
}

.tab-bar > div.active {
  font-weight: normal;
  color: #222222;
  background-color: #ffffff;
}

.tab-bar_fixed > div.active > div {
  border-bottom: 4px solid #1da7fc;
  height: 44px;
  width: fit-content;
  margin: auto;
}

.tab-bar > div {
  flex: 1;
  text-align: center;
  height: 100%;
  line-height: 44px;
}

.tab-content {
  background-color: #ffffff;
  padding: 16px 16px 66px 16px;
  .content-wrap {
    padding-bottom: 10vh;
  }
}

.info-title {
  font-size: 16px;
  font-weight: bold;
  color: #222222;
}

::v-deep .info-content {
  font-size: 15px;
  line-height: 24px;
  color: #7a7a7a;
  img {
    width: 100% !important;
    height: auto !important;
  }
  table {
    width: 100% !important;
    height: auto !important;
  }
}

.info-image img {
  width: 100%;
}

.store-item {
  margin-bottom: 16px;
}

.store-item > p {
  margin-bottom: 8px;
  font-size: 15px;
  font-weight: normal;
  color: #222222;
}

.store-item > div {
  margin-bottom: 0px;
  font-size: 15px;
  line-height: 24px;
  color: #7a7a7a;
}

.store-item:last-child {
  margin-bottom: 0px;
}

.footer-bar {
  height: 66px;
  backdrop-filter: blur(20px);
  background-color: rgba(247, 247, 247, 0.8);
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100vw;
  box-shadow: 0 -0.5px 0 0 rgba(0, 0, 0, 0.3), 0 1px 8px 0 rgba(0, 0, 0, 0.08);
}

.footer-bar .disabled-btn {
  opacity: 0.5;
}

.footer-bar > div {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  font-weight: lighter;
  color: #6d7278;
}

.footer-bar img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.footer-bar .v-btn {
  flex-grow: 2;
}

.refundImg {
  width: 40px !important;
  height: 40px !important;
  margin: -6px -8px -10px -8px;
  display: block;
}

.info-block-text > div {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
}

.info-block-text > div > div:first-child {
  color: #9b9b9b;
}

.info-block-text > div > div:last-child {
  color: #7a7a7a;
}

.info-block-text > div > div.dark-text {
  color: #222222 !important;
  font-weight: normal;
}

.text-divider {
  box-shadow: inset 0 -1px 0 0 #ededed;
  padding-bottom: 10px;
}

.purchase-date,
.redeem-records-item {
  color: #7a7a7a;
  font-size: 15px;
}

.redeem-records-item > div:last-child {
  display: flex;
}

.redeem-records-item > div > div.dark-text {
  color: #222222 !important;
}

.item-tag {
  width: 1px;
  height: 22px;
  margin-top: 2px;
}

.progress-id {
  font-size: 15px;
  color: #4a4a4a;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  padding: 6px 0px;
  box-shadow: inset 0 -1px 0 0 #ededed;
}

.progress-content {
  height: 92px;
  overflow: hidden;
  transition: height 0.5s;
  position: relative;
  border-bottom: solid 1px #ededed;
}

.progress-item {
  display: flex;
  align-items: center;
  padding: 11px 0 0 0;
}

.fade-cover {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 40px;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
}

.progress-item-text {
  font-size: 15px;
  line-height: 24px;
  color: #7a7a7a;
}

.progress-item-date {
  margin-left: 1rem;
  font-size: 0.8rem;
}

.progress-item-image {
  width: 20px;
  height: 20px;
  position: relative;
}

.progress-item-image > img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

div.progress-item + div.progress-item > div.progress-item-image::before {
  content: '';
  width: 1px;
  height: 20px;
  border: solid 2px #1da7fc;
  position: absolute;
  left: 8px;
  top: -20px;
}

.progress-expand {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  line-height: 24px;
  color: #4a4a4a;
}

.product-info-block {
  padding: 16px;
}

.expire-notify {
  position: relative;
  padding: 12px 0px 0px;
  height: 34px;
}

.pill-badge-expire {
  padding: 2px 8px;
  padding-right: 16px;
  border-radius: 10px;
  background-color: #76ad6f;
  font-size: 13px;
  color: #ffffff;
  position: absolute;
  right: -8px;
  height: 22px;
  line-height: 1.5;
}

.order-number {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  align-items: center;
}
.order-number-content {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #4a4a4a;
}

.order-number-content > img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 10px;
}

.order-number-code {
  display: flex;
  flex-direction: column;
}

.order-number-copy {
  font-size: 14px;
  line-height: 24px;
  color: #9b9b9b;
  cursor: pointer;
}

.order-number-copy > img {
  margin-left: 6px;
  width: 12px;
  height: 12px;
  object-fit: contain;
}

.product-image {
  width: 100vw;
  overflow: hidden;
  background: url('../../assets/img/placholder_512.svg');
  background-size: contain;
  background-repeat: no-repeat;
  font-size: 0;
  line-height: 0;
  img {
    background-color: #fff;
    width: 100%;
    height: 100%;
    &.none {
      display: none;
      & ~ .none-img {
        height: 100vw;
      }
    }
  }
}

.product-name {
  font-size: 20px;
  font-weight: normal;
  color: #222222;
  margin-bottom: 8px;
}

.product-info {
  font-size: 15px;
  line-height: 22px;
  color: #4a4a4a;
}

.pill-badge {
  width: fit-content;
  padding: 2px 12px;
  border-radius: 21px;
}

.pill-badge_deliver {
  background-color: rgba(22, 150, 255, 0.08) !important;
  color: #1696ff;
  margin-bottom: 8px;
}
.copy-success-div {
  position: fixed;
  color: #fff;
  top: 50%;
  left: 50%;
  min-height: 50px;
  width: 80%;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  opacity: 0.7;
  background-color: #000;
}

.order-top {
  margin-bottom: 16px;  
}

.product-top {
  display: flex;
  margin-bottom: 24px;
  .product-img {
    flex: 2;
    margin-right: 16px;
    img {
      width: 100%;
      border-radius: 16px;
    }
  }
  .product-info {
    flex: 5;
    h1 {
      font-size: 16px;
      font-weight: 600;
      color: #2a2b2b;
    }
    .product-type {
      font-size: 10px;
      padding: 0px 8px;
      color: #fff;
      background-color: #ffbf56;
      border-radius: 30px;
      display: inline-block;
      line-height: 18px;
    }
    .product-expire {
      color: #8e9091;
      font-size: 14px;
    }
  }
}

.product-btm {
  padding: 40px 0;
  p {
    text-align: center;
    color: #2a2b2b;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 24px;
  }
}

.hr {
  background-color: #ccc;
  height: 2px;
  width: 100%;
}

.order-btm {
  .hr {
    width: 100%;
    background-color: #ddd;
    height: 2px;
    margin: 10px 0;
  }
  h2 {
    font-size: 14px;
    font-weight: 600;
    color: #2a2b2b;
    margin-bottom: 8px;
  }
  p {
    color: #8e9091;
    font-size: 14px;
  }
  .info-row {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.inline-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.orderNo-copy {
  cursor: pointer;
  font-size: 14px;
  color: #2a2b2b;
  display: flex;
  align-items: center;
}

.dark-text {
  color: #2a2b2b;
}

>>> .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #c0c2c4 !important;
  .v-btn__content {
    color: #fff;
  }
}

>>> .v-btn--outlined {
  border-width: 2px;
}

</style>
